module.exports = __webpack_public_path__ + "src/assets/img/scroll-bg4.80a837f3.png";